import React from "react";

const CheckboxField = ({ label, checked, onChange, disabled = false }) => {
  return (
    <div className="field">
      <div className="control">
        <label className="checkbox is-size-7">
          <input
            style={{ verticalAlign: "middle" }}
            id="checkbox-input"
            type="checkbox"
            checked={checked}
            onChange={onChange}
            disabled={disabled}
          />{" "}
          {label}
        </label>
      </div>
    </div>
  );
};

export default CheckboxField;
